import React from 'react';
import { AnimatePresence, motion } from 'motion/react';
import { EASE_OUT } from '../../motion/tokens';
import usePrefersReducedMotion from '../../motion/usePrefersReducedMotion';

export default function InlineLoading({
  show = true,
  label = 'Updating…',
  className = '',
}) {
  const reduced = usePrefersReducedMotion();

  return (
    <AnimatePresence>
      {show ? (
        <motion.div
          className={`inline-flex items-center gap-2 rounded-full border border-teal-100 bg-teal-50/90 px-3 py-1.5 text-xs font-semibold text-teal-800 shadow-sm ${className}`.trim()}
          initial={reduced ? false : { opacity: 0, y: -4 }}
          animate={{ opacity: 1, y: 0 }}
          exit={reduced ? undefined : { opacity: 0, y: -4 }}
          transition={{ duration: reduced ? 0 : 0.18, ease: EASE_OUT }}
          role="status"
          aria-live="polite"
        >
          <span
            className={`h-3.5 w-3.5 rounded-full border-2 border-teal-200 border-t-teal-600 ${
              reduced ? '' : 'animate-spin'
            }`}
            aria-hidden="true"
          />
          {label}
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
}
